export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://192.168.1.10:3000';
export const API_VERSION = 'v1';
export const PRINTS_SOCKET_PATH = '/printers';

const buildAuthRoute = (route: string, version = API_VERSION) => {
  return `${API_BASE_URL}/api/${version}/auth/${route}`;
};

const buildApiRoute = (route: string, version = API_VERSION) => {
  return `${API_BASE_URL}/api/${version}/${route}`;
};

export const EndPoints = Object.freeze({
  updateUserPassword: buildAuthRoute('password/update'),
  login: buildAuthRoute('login'),
  resetPasswordEmailRequest: buildAuthRoute('emails/reset-password'),
  userInfo: buildApiRoute('me'),
  searchCustomerByField: buildApiRoute('customers/search/ByField'),
  clientDeliveryPaymentIntent: buildApiRoute('clientDeliveryPayments/intent'),
  clientDeliveryPaymentCreateStripCheckoutSession: buildApiRoute('clientDeliveryPayments/create-stripe-session'),
  receiversOfCustomer: buildApiRoute('customers/receiver/all'),
  createNewReceiverCustomer: buildApiRoute('customers/receiver/create/new'),
  createNewCustomer: buildApiRoute('customers/create/new'),
  appConfigs: buildApiRoute('appConfigs'),
  createNewShipping: buildApiRoute('shipping/create/new'),
  getShippingData: buildApiRoute('shipping/details'),
  createNewWeightColi: buildApiRoute('shipping/colis/new/weight'),
  createNewPriceColi: buildApiRoute('shipping/colis/new/price'),
  createNewValueColi: buildApiRoute('shipping/colis/new/value'),
  colisListByShippingId: buildApiRoute('shipping/colis/list'),
  removeColiById: buildApiRoute('shipping/colis/remove'),
  shippingCheckoutDraft: buildApiRoute('shipping/checkout/on/draft'),
  shippingCurrentTotal: buildApiRoute('shipping/checkout/current/total'),
  submitShippingCheckout: buildApiRoute('shipping/checkout/submit'),
  getColiTrackingInfo: buildApiRoute('shipping/colis/info/tracker'),
  publicClientDeliveryRequest: buildApiRoute('public/client/deliveryRequest'),
  clientDeliveryRequestReject: buildApiRoute('deliveryRequest/rejectByCustomer'),
  transferColiToAgency: buildApiRoute('shipping/colis/transfer/to/agency'),
  transferColiToVoyageLoaded: buildApiRoute('shipping/colis/transfer/to/loaded'),
  getDraftVoyages: buildApiRoute('voyage/get/draft'),
  createVoyage: buildApiRoute('voyage/create'),
  updateVoyage: buildApiRoute('voyage/update'),
  deleteVoyage: buildApiRoute('voyage/delete'),
  getColisForVoyage: buildApiRoute('voyage/get/colis'),
  getDrivers: buildApiRoute('organization/drivers/get/all'),
  transferColiToWarehouse: buildApiRoute('shipping/colis/transfer/to/warehouse'),
  appendNewItemToPriceCatalog: buildApiRoute('organization/catalog/price/new'),
  search: buildApiRoute('search/hits'),
  getColiTrackingPublic: buildApiRoute('tracking/public/colis'),
  getAgencyInfoBySlug: buildApiRoute('public/agency/info/by/slug'),
  getAdvisorCatalog: buildApiRoute('public/advisor/catalog'),
  deliveryPublicColiInfo: buildApiRoute('delivered/public/colis/info'),
  clientRequestDeliveryTracking: buildApiRoute('clientDeliveryTracking'),
  clientRequestDeliveryWithRating: buildApiRoute('clientDeliveryForRating'),
  clientDeliveryRating: buildApiRoute('clientDeliveryRating'),
  clientRequestDeliveryGetRequestToConfirmAction: buildApiRoute('clientDeliveryCanActionConfirm'),
  searchForPrint: buildApiRoute('search/to/print'),
  clientPublicEStoreCreate: buildApiRoute('public/client/estore/create'),
  clientPublicInStoreCreate: buildApiRoute('public/client/instore/create'),
  clientPublicHomeToStoreCreate: buildApiRoute('public/client/homeToStore/create'),
  nearbyMappedAgencies: buildApiRoute('public/client/nearbyMappedAgencies'),
  getOcm: buildApiRoute('organization/consumption/amount'),
  getDashboardAgencies: buildApiRoute('dashboard/admin/agencies'),
  getDashboardAgency: buildApiRoute('dashboard/admin/agencies/agency/:id'),
  updateDashboardAgency: buildApiRoute('dashboard/admin/agencies/agency/:id'),
  getDashboardUsers: buildApiRoute('dashboard/admin/users'),
  getDashboardUser: buildApiRoute('dashboard/admin/users/user/:id'),
  organizationStats: buildApiRoute('dashboard/admin/stats'),
  dashboardUserCreation: buildApiRoute('dashboard/admin/users/create'),
  dashboardUserUpdate: buildApiRoute('dashboard/admin/users/user/:id'),
});
